export default __webpack_public_path__ + "static/waxcarvers-be5719a37d0b0c0485ed78b23909325e.webp";